import { useEffect, useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const HERO_VIDEO_DESKTOP = "/videos/tilio-domki-nad-liwcem-mazowsze.mp4?v=2";
const HERO_VIDEO_MOBILE = "/videos/tilio-domki-nad-liwcem-mazowsze-720p.mp4?v=2";
const HERO_POSTER = "/videos/tilio-hero-poster.jpg";

export default function Hero() {
    const ref = useRef(null);
    const videoRef = useRef(null);
    // Decide the source ONCE on mount based on viewport so the browser
    // fetches only a single file (mobile gets the lighter 720p version).
    const [videoSrc] = useState(() => {
        if (typeof window !== "undefined" && window.matchMedia && window.matchMedia("(max-width: 767px)").matches) {
            return HERO_VIDEO_MOBILE;
        }
        return HERO_VIDEO_DESKTOP;
    });
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

    useEffect(() => {
        const v = videoRef.current;
        if (!v) return;
        // Ensure muted inline autoplay works reliably across browsers (incl. mobile)
        v.muted = true;
        const tryPlay = () => {
            const p = v.play();
            if (p && typeof p.catch === "function") p.catch(() => {});
        };
        tryPlay();
    }, []);

    return (
        <section ref={ref} data-testid="hero-section" className="relative h-[78vh] min-h-[520px] overflow-hidden">
            <motion.div style={{ y }} className="absolute inset-0 scale-110">
                <motion.video
                    ref={videoRef}
                    src={videoSrc}
                    poster={HERO_POSTER}
                    title="Tilio – domki nad Liwcem na Mazowszu"
                    aria-label="Tilio – domki nad Liwcem na Mazowszu, jacuzzi i sauna"
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="metadata"
                    data-testid="hero-video"
                    initial={{ scale: 1.08 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 2, ease: [0.16, 1, 0.3, 1] }}
                    className="h-full w-full object-cover"
                >
                    Tilio – kameralne domki na wynajem nad rzeką Liwiec na Mazowszu. Natura, jacuzzi, sauna i spokojny wypoczynek blisko Warszawy.
                </motion.video>
            </motion.div>
            <div className="absolute inset-0 bg-pine/35" />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-pine/40 to-transparent pb-12 pt-32" />
        </section>
    );
}
